// Define column width classes at the top for easy modification
export const columnWidths = {
  team: 'w-[180px]',
  channel: 'w-[300px]',
  time: 'w-[250px]',
  createdBy: 'w-[180px]',
  action: 'w-[80px]'
}

export const StandupTableColumn = () => {
  return (
    <thead className="bg-gray-50">
      <tr>
        <th
          scope="col"
          className={`py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6 ${columnWidths.team}`}
        >
          Team
        </th>
        <th
          scope="col"
          className={`px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 ${columnWidths.channel}`}
        >
          Channel
        </th>
        <th
          scope="col"
          className={`px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 ${columnWidths.time}`}
        >
          Time
        </th>
        <th
          scope="col"
          className={`px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 ${columnWidths.createdBy}`}
        >
          Created by
        </th>
        <th scope="col" className={`relative py-3 pl-3 pr-4 sm:pr-6 ${columnWidths.action}`}>
          <span className="sr-only">Action</span>
        </th>
      </tr>
    </thead>
  )
}
